// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CtvjE","field":"styles_field__2R6WA","fieldCol":"styles_fieldCol__1ySSE","diffCol":"styles_diffCol__L1Bn2","diff":"styles_diff__3ayjP"};